var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    "data-name": "Group 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.67,
    height: 164,
    viewBox: "0 0 194.67 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 194.67,
    height: 164,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M177.5,112.67a27.268,27.268,0,0,1,13.859,15.963,14.371,14.371,0,0,1,.663,2.768c1.028,7.817-4.662,14.7-10.738,18.932l-1.349.971-.032.023a1.923,1.923,0,0,0-.475,2.624l1.143,1.711c3.1,4.873,4.807,11,3.12,16.615-1.842,6.411-6.947,10.271-13.128,12.234a19.451,19.451,0,0,1-8.262.917,17.438,17.438,0,0,1-6.072-2.207,29.269,29.269,0,0,1-6.333-4.914,1.742,1.742,0,0,0-2.744,2.106,23.9,23.9,0,0,0,6.33,6.972,19.682,19.682,0,0,0,7.837,3.678c6.2,1.187,12.386-.6,17.635-3.753a21.372,21.372,0,0,0,10.475-21.04,25.539,25.539,0,0,0-7.351-14.556l-.506,2.647c.551-.245,1.1-.5,1.647-.761a29.225,29.225,0,0,0,10.222-8c5.239-6.766,6.118-14.71,2.238-22.432a26.592,26.592,0,0,0-10.081-11.25,19.427,19.427,0,0,0-7.161-2.591,1.75,1.75,0,0,0-.938,3.339",
    transform: "translate(-67.094 -61.93)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M294.587,88.25c-10.642-.458-20.852,7.835-21.312,18.968.091,10.411,8.132,20.871,18.78,21.723.009.008-.671-3.121-.668-3.121a30.033,30.033,0,0,0-4.638,3.061A18.325,18.325,0,0,0,280,138.688a15.811,15.811,0,0,0,18.482,18.926,1.761,1.761,0,0,0-.081-3.466,23.4,23.4,0,0,1-4.478-1.3c-4.875-1.911-8.738-6.621-8.412-11.975.366-5,4.394-8.876,7.874-12.211l.359-.362a1.621,1.621,0,0,0-1.033-2.76,19.2,19.2,0,0,1-9.494-7.273,20.75,20.75,0,0,1-3.9-10.986c.2-5.857,4.394-11.093,9.547-13.627a22.775,22.775,0,0,1,5.986-1.949,1.743,1.743,0,0,0-.266-3.451",
    transform: "translate(-223.678 -49.986)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M102.637,46.678c1.392-14.9,18-20.338,30.674-15.918,9.658,3.3,16.207,11.964,19.973,21.281a30.2,30.2,0,0,1-1.5,27.531,43.91,43.91,0,0,1-9.455,11.246,1.734,1.734,0,0,0,2.2,2.682A46.34,46.34,0,0,0,155.41,81.764c6.128-9.206,6.995-21.459,2.993-31.686-2.769-7.711-7.131-15.158-13.827-20.144a32.067,32.067,0,0,0-32.119-3.554c-7.743,3.511-13.624,11.614-13.286,20.205a1.738,1.738,0,0,0,3.466.093",
    transform: "translate(-9.155 -13.378)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M1.069,168.512c20.153,17.328,42.938,30.973,65.922,43.994a1.517,1.517,0,0,0,1.546-2.611c-22.206-13.734-44.292-28.131-63.414-45.9a3.035,3.035,0,1,0-4.054,4.517",
    transform: "translate(125.414 -92.437)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M22.165,276.213c23.5-.127,47.221,2.2,69.936,8.419a1.517,1.517,0,0,0,.885-2.9c-5.7-1.847-11.49-3.423-17.326-4.778a284.031,284.031,0,0,0-53.452-6.808,3.035,3.035,0,1,0-.043,6.069",
    transform: "translate(92.362 -153.044)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M85.423,257.867a176.339,176.339,0,0,0-41.858-10.3,1.521,1.521,0,0,0-.5,2.993l10.366,2.5c5.992,1.473,14.627,3.695,20.694,5.247,3.459.867,6.924,1.724,10.429,2.468a1.524,1.524,0,0,0,.869-2.907",
    transform: "translate(90.123 -140.251)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M94.9,209.038a85.465,85.465,0,0,0,11.073,7.511,99.527,99.527,0,0,0,11.893,6.137,1.52,1.52,0,0,0,1.342-2.722c-1.869-1.094-3.74-2.226-5.616-3.353l-5.629-3.4c-3.732-2.268-7.548-4.531-11.335-6.668a1.524,1.524,0,0,0-1.727,2.491",
    transform: "translate(33.804 -116.901)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M222.894,276c1.915,8.856-1.452,18.458-7.477,25.06a40.35,40.35,0,0,1-20.744,11.473c-7.989,1.628-17.121.186-23-5.6-5.842-5.663-10.143-14.175-8.339-22.384a1.737,1.737,0,0,0-3.267-1.164,16.823,16.823,0,0,0-1.136,3.684,23.457,23.457,0,0,0,.79,11.3A31.928,31.928,0,0,0,170.4,313.7c11.47,8.369,27.664,6.313,39.089-.933a47.608,47.608,0,0,0,8.6-6.859,34.832,34.832,0,0,0,6.236-9.211c3.074-6.709,4.181-14.529,1.906-21.654a1.736,1.736,0,0,0-3.335.951",
    transform: "translate(-101.501 -155.147)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M351.95,254.794c-13.448,8.625-30.242,4.331-39.34-8.359a30.916,30.916,0,0,1-5.356-17.708,35.41,35.41,0,0,1,8.549-23.278,42.07,42.07,0,0,1,9.984-8.241,1.736,1.736,0,0,0-1.508-3.122l-1.662.7a36.038,36.038,0,0,0-4.8,2.561c-17.4,10.817-21.9,36.081-9.855,52.543a35.724,35.724,0,0,0,17.93,12.754,31.043,31.043,0,0,0,28.054-5,1.736,1.736,0,0,0-1.99-2.84",
    transform: "translate(-290.512 -109.879)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M247.425,87.616c-8.078-1.721-15.112-9.343-18.876-16.419a35.863,35.863,0,0,1-2.619-24.8,25.969,25.969,0,0,1,14.9-16.851,25.287,25.287,0,0,1,16.9-1.81,23.957,23.957,0,0,1,5.962,2.277,19.627,19.627,0,0,1,2.588,1.72,1.73,1.73,0,0,0,2.92-1.556,18.277,18.277,0,0,1,1.313-7.946,24.927,24.927,0,0,1,6.753-9.521c.624-.461,1.366-1.139,2.011-1.571l1.7-1.13c4.645-2.66,10.116-4.384,15.506-3.911a22.422,22.422,0,0,1,14.1,7.005,22.5,22.5,0,0,1,4.62,6.738,1.739,1.739,0,0,0,3.348-.9,18.452,18.452,0,0,0-1.64-4.783A26.346,26.346,0,0,0,306.775,3.315c-6.6-3.96-15.092-4.252-22.165-1.506a27.532,27.532,0,0,0-3.448,1.436c-.719.279-2.562,1.434-3.271,1.839a36.031,36.031,0,0,0-4.424,3.5,30.527,30.527,0,0,0-4.319,5.365,23.766,23.766,0,0,0-3.712,14.965c.059.429.274,1.456.36,1.9l2.92-1.555c-5.909-5.864-14.706-8.064-22.822-6.931a32.587,32.587,0,0,0-7.272,2.078l-.879.349-.843.4c-8.16,3.669-14.76,10.829-16.985,19.592A37.222,37.222,0,0,0,219.13,59.7a37.883,37.883,0,0,0,8.977,20.173A36.32,36.32,0,0,0,239.7,89a21.172,21.172,0,0,0,7.339,2.06,1.735,1.735,0,0,0,.382-3.447",
    transform: "translate(-218.724 -0.001)",
    fill: "#1a1a1a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreath);
export default __webpack_public_path__ + "static/media/breath.5574e8fd9a146d96c5e8fd921cdd6c57.svg";
export { ForwardRef as ReactComponent };